import { render } from "./CreateBlockComponent.vue?vue&type=template&id=41fad34f&scoped=true"
import script from "./CreateBlockComponent.vue?vue&type=script&lang=js"
export * from "./CreateBlockComponent.vue?vue&type=script&lang=js"

import "./CreateBlockComponent.vue?vue&type=style&index=0&id=41fad34f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41fad34f"

export default script